import { render, staticRenderFns } from "./FormControlTypeJson.vue?vue&type=template&id=2133543c&scoped=true"
import script from "./FormControlTypeJson.vue?vue&type=script&lang=js"
export * from "./FormControlTypeJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2133543c",
  null
  
)

export default component.exports